/* src/app/master-data/customers/customers-list/customers-list.component.css */
/*# sourceMappingURL=customers-list.component-KJ35SGWV.css.map */
